import { createFileRoute } from '@tanstack/react-router';
import { AdminHealthPage } from '@/components/admin/admin-health';

export const Route = createFileRoute('/admin/health')({
  component: AdminHealthPage,
});
